import { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";
import arrowImg from "../../../../picture/PlayLanguage.png";
import archiveImg from "../../../../picture/letterA.png";
import notifImg from "../../../../picture/notification.png";
import Dodavanje from "../evidencije/evidencije6/Dodavanje";
import Preview from "../evidencije/evidencije6/Preview";
import { useGlobalContext } from "../../../../Context/Context";
import axios from "axios";

const st = {
  cell: { padding: "5px", textAlign: "center", fontSize: "14px" },
  smallCell: { width: "30px", textAlign: "center" },
};

const mapZaposlenToObrazac6 = (zaposlen) => {
  if (!zaposlen) return null;
  return {
    ...zaposlen,
    zaposlen: { id: zaposlen.id, name: `${zaposlen.ime} ${zaposlen.prezime}` },
    radnoMesto: { id: zaposlen.workplace_id, name: zaposlen.radnoMesto },
    lzo: [],
    prati: [],
    mere: [],
  };
};

function Obrazac6Zaposlen({ zaposlen, handleZatvori, lookups }) {
  const [data, setData] = useState([]);
  const [currentState, setCurrentState] = useState(""); // "" | "DODAVANJE" | "PREVIEW"
  const [previewData, setPreviewData] = useState(null);

  const { baseUrl, selectedMainEntity, dictionary } = useGlobalContext();

  const fetchData = async () => {
    try {
      const { data: res } = await axios.post(`${baseUrl}/evidencija6/read.php`, {
        company_id: selectedMainEntity.company_id,
        employee_id: zaposlen.id,
      });
      if (res.status === 200) setData(res.data);
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    fetchData();
  }, [zaposlen]);

  const handlePreview = async (id) => {
    try {
      const { data: res } = await axios.post(`${baseUrl}/evidencija6/readOne.php`, { id });
      if (res.status === 200) { setPreviewData(res.data); setCurrentState("PREVIEW"); }
    } catch (e) { console.error(e); }
  };

  const handleArchive = async (id) => {
    try {
      await axios.post(`${baseUrl}/evidencija6/archive.php`, { id });
      fetchData();
    } catch (e) { console.error(e); }
  };

  if (currentState === "DODAVANJE")
    return (
      <Dodavanje
        handleZatvori={() => { setCurrentState(""); fetchData(); }}
        editData={mapZaposlenToObrazac6(zaposlen)}
        lookups={lookups}
        sacuvajAzurirano={fetchData}
      />
    );

  if (currentState === "PREVIEW" && previewData)
    return (
      <Preview
        id={previewData.id}
        cancel={() => { setCurrentState(""); setPreviewData(null); }}
        data={previewData}
        lookups={lookups}
        onRefresh={fetchData}
      />
    );

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "90%", justifyContent: "space-between" }}>
      <div style={{ overflowY: "auto", height: "calc(100% - 60px)", backgroundColor: "white", padding: "5px", border: "1.5px solid #9f9f9f" }}>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={st.cell}>#</th>
              <th style={st.cell}>{dictionary["imeIPrezime"]}</th>
              <th style={st.cell}>{dictionary["radnoMesto"]}</th>
              <th style={st.cell}>{dictionary["datum"]}</th>
              <th style={st.cell}>{dictionary["razlog"]}</th>
              <th style={st.smallCell}><img src={notifImg} style={{ width: "25px" }} /></th>
              <th style={st.cell}></th>
              <th style={st.cell}></th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && (
              <tr><td colSpan={8} style={{ textAlign: "center", padding: "20px", color: "#888" }}>Nema obrazaca 6 za ovog zaposlenog</td></tr>
            )}
            {data.map((item, i) => (
              <tr key={item.id}>
                <td style={st.cell}>{i + 1}.</td>
                <td style={st.cell}>{item.zaposleni_naziv}</td>
                <td style={st.cell}>{item.radno_mesto_naziv}</td>
                <td style={st.cell}>{item.teorija_datum}</td>
                <td style={st.cell}>{item.razlog}</td>
                <td style={st.cell}>
                  <div style={{
                    width: "25px", height: "25px", margin: "0 auto",
                    backgroundColor: item.status === "ISTEKAO" ? "red" : item.status === "USKORO_ISTICE" ? "orange" : item.status === "NIJE_ISTEKAO" ? "green" : ""
                  }} />
                </td>
                <td onClick={() => handlePreview(item.id)} style={{ ...st.smallCell, cursor: "pointer" }}>
                  <img src={arrowImg} style={{ width: "30px" }} />
                </td>
                <td onClick={() => handleArchive(item.id)} style={{ ...st.smallCell, cursor: "pointer" }}>
                  <img src={archiveImg} style={{ width: "20px" }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
        <div onClick={handleZatvori}>
          <Button activation={true} style={{ fontWeight: "bold" }}>НАЗАД</Button>
        </div>
        <div onClick={() => setCurrentState("DODAVANJE")}>
          <Button activation={true} style={{ fontWeight: "bold" }}>{dictionary["dodaj"]}</Button>
        </div>
      </div>
    </div>
  );
}

export default Obrazac6Zaposlen;